import { useCallback, useState } from "react";
import { Button } from "@mui/material";
import { Download } from "@mui/icons-material";

import {
  API_TOTALREWARD_SERVICE,
  restApiRequestFormData,
  getFileNameFromResponse,
  saveFile,
} from "src/utils/Api";
import newRelicErrorReport from "src/utils/newRelic/newRelicErrorReport";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import { useCompanyId } from "src/Pages/Company/CompanyContext";

const ExportPerks = () => {
  const companyId = useCompanyId();

  const [loading, setLoading] = useState(false);

  const exportPerks = useCallback(async () => {
    try {
      setLoading(true);
      const response = await restApiRequestFormData(
        API_TOTALREWARD_SERVICE,
        `/omb/perk-exports?tenant=${companyId}`,
        "GET",
        null,
        undefined,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const blob = await response.blob();
      const resultFileName =
        getFileNameFromResponse(response) ||
        `export_total_reward_benefits.xlsx`;
      saveFile(blob, false, resultFileName);
      setLoading(false);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      dynamicNotification([
        __(e.message || "Nie udało się pobrać pliku. Wystąpił nieznany błąd"),
      ]);
      newRelicErrorReport(
        e,
        "Pages/Company/TotalReward/Perks/ExportPerks.js - 24"
      );
    }
  }, [companyId]);

  return (
    <>
      <Button
        variant="contained"
        disabled={loading}
        startIcon={<Download />}
        onClick={() => exportPerks()}
      >
        {loading ? __("Pobieranie pliku") : __("Eksportuj benefity")}
      </Button>
    </>
  );
};

export default ExportPerks;
